/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";
import {
	GetWindTurbine,
	GetWindTurbineError,
	GetWindTurbineSuccess,

} from "@/stores/actions/WindTurbine";

const state = {
	status:         FetchStatus.Init,
	successMessage: "",
	errorMessage:   "",
	data:           {},
};

const getters = { turbine: state => state.data.windTurbines[0] };

const actions = {

	[GetWindTurbine]: ({ commit }, monitoringElementId) =>
	{
		http.get(`/WindTurbines/${monitoringElementId}`)
			.then((resp) =>
			{
				const windTurbine = resp.data;
				commit(GetWindTurbineSuccess, windTurbine);
			})
			.catch((error) =>
			{
				commit(GetWindTurbineError, error);
			});
	},

};
const mutations = {
	[GetWindTurbine]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GetWindTurbineSuccess]: (state, windTurbine) =>
	{
		state.data = windTurbine;
		state.status = FetchStatus.Loaded;
	},
	[GetWindTurbineError]: (state, error) =>
	{
		state.error = error.response;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
	getters
};
